import { usePageProperties } from 'hooks/usePageProperies'

export const useSitePhone = () => {
  const { sitePhone, sitePhoneLink } = usePageProperties()
  return [sitePhone, sitePhoneLink]
}
